import * as React from 'react';
import { overrideCSS } from '../../utils/function';
import { addItemToGoogleTracking } from "../../utils";

import { IAppParams, IDocuments } from "../../models";
const FaPDF = require('react-icons/lib/fa/file-pdf-o');

const internalStyles = require('./PDFIconDownload.pcss');

interface IProps {
    styles?: string
    documents?: IDocuments[];
    appParams?: IAppParams;
    type: string;
    row?: any; 
}

export class PDFIconDownload extends React.Component<IProps, {}>{
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        let { type, row, appParams } = this.props;
        event.stopPropagation();
        addItemToGoogleTracking(appParams, "fund_download", { eventCategory: row.clientCode, eventLabel: type });
        
    }

    getDocumentDownload(doc, styles) {
        if (doc) {
            return (
                <a
                    href={doc.URL}
                    onClick={this.handleClick}
                    target="_blank"
                    className={styles.anchor}>
                    <FaPDF />
                </a>
            );
        } else {
            return <span className={styles.noPDF}>-</span>
        }
    }

    render() {
        let styles = this.props.styles ? overrideCSS(internalStyles, this.props.styles) : internalStyles;
        let { documents, appParams, type } = this.props;
        let { language, clienttype, region } = appParams
        let doc = documents.filter(item => {
            let isValidDoc = item.meta.document_type.value === type &&
                item.meta.client_type.value === clienttype &&
                item.meta.language.value === language &&
                item.meta.registration.value === region &&
                !item.meta.is_deleted.value;

            if (isValidDoc) {
                return item;
            }
        }).shift();

        return this.getDocumentDownload(doc, styles);
    }
}


// WEBPACK FOOTER //
// ./src/client/assets/PDFIconDownload/PDFIconDownload.tsx